"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PseudoElementType = exports.CustomElementType = exports.MetaInputType = exports.MetaField = exports.ParserType = exports.ObjectField = exports.ObjectType = exports.ItemStatus = void 0;
var ItemStatus;
(function (ItemStatus) {
    ItemStatus["Created"] = "CREATED";
    ItemStatus["Existed"] = "EXISTED";
    ItemStatus["Deleted"] = "DELETED";
    ItemStatus["Changed"] = "CHANGED";
})(ItemStatus = exports.ItemStatus || (exports.ItemStatus = {}));
var ObjectType;
(function (ObjectType) {
    ObjectType["Jmr"] = "Jmr";
    ObjectType["Agenda"] = "AgendaItems";
    ObjectType["Action"] = "ActionItems";
    ObjectType["Transcript"] = "TranscriptItems";
})(ObjectType = exports.ObjectType || (exports.ObjectType = {}));
var ObjectField;
(function (ObjectField) {
    ObjectField["Object"] = "object";
    ObjectField["Irrelevant"] = "irrelevant";
    ObjectField["Meta"] = "meta";
    ObjectField["Title"] = "title";
    ObjectField["Purpose"] = "purpose";
    ObjectField["Description"] = "description";
    ObjectField["Notes"] = "notes";
    ObjectField["Dialogue"] = "dialogue";
})(ObjectField = exports.ObjectField || (exports.ObjectField = {}));
var ParserType;
(function (ParserType) {
    ParserType["Simple"] = "simple";
    ParserType["Rich"] = "rich";
    ParserType["Meta"] = "meta";
    ParserType["Object"] = "object";
})(ParserType = exports.ParserType || (exports.ParserType = {}));
var MetaField;
(function (MetaField) {
    MetaField["DueDate"] = "dueDate";
    MetaField["StartDate"] = "startDate";
    MetaField["EndDate"] = "endDate";
    MetaField["Assignee"] = "assignee";
    MetaField["Duration"] = "duration";
    MetaField["Location"] = "location";
    MetaField["SeqNum"] = "seqNum";
    MetaField["Owner"] = "owner";
    MetaField["Participants"] = "participants";
    MetaField["Status"] = "status";
    MetaField["Speaker"] = "speaker";
    MetaField["Generated"] = "isGenerated";
})(MetaField = exports.MetaField || (exports.MetaField = {}));
var MetaInputType;
(function (MetaInputType) {
    MetaInputType[MetaInputType["datePicker"] = 0] = "datePicker";
    MetaInputType[MetaInputType["timePicker"] = 1] = "timePicker";
    MetaInputType[MetaInputType["assignee"] = 2] = "assignee";
    MetaInputType[MetaInputType["duration"] = 3] = "duration";
    MetaInputType[MetaInputType["location"] = 4] = "location";
    MetaInputType[MetaInputType["participants"] = 5] = "participants";
    MetaInputType[MetaInputType["none"] = 6] = "none";
})(MetaInputType = exports.MetaInputType || (exports.MetaInputType = {}));
var CustomElementType;
(function (CustomElementType) {
    CustomElementType["JmrTitle"] = "jmr-title";
    CustomElementType["JmrHeader"] = "jmr-header";
    CustomElementType["TextBlock"] = "text-block";
    CustomElementType["RichText"] = "rich-text";
    CustomElementType["SimpleText"] = "simple-text";
    CustomElementType["MetaContainer"] = "meta-container";
    CustomElementType["Meta"] = "meta";
    CustomElementType["Agenda"] = "agenda";
    CustomElementType["AgendaItem"] = "agenda-item";
    CustomElementType["ActionList"] = "action-list";
    CustomElementType["ActionItem"] = "action-item";
    CustomElementType["Transcript"] = "transcript";
    CustomElementType["Utterance"] = "utterance";
    CustomElementType["BulletedList"] = "bulleted-list";
    CustomElementType["NumberedList"] = "numbered-list";
    CustomElementType["ListItem"] = "list-item";
    CustomElementType["Hidden"] = "placeholder";
})(CustomElementType = exports.CustomElementType || (exports.CustomElementType = {}));
var PseudoElementType;
(function (PseudoElementType) {
    PseudoElementType["JmrOptions"] = "jmr-options";
})(PseudoElementType = exports.PseudoElementType || (exports.PseudoElementType = {}));
